<template>
    <div class="findPassword">
        <form action="" id="findForm">
            <div class="input input1">
                <input type="text" :placeholder="$t('placeholder_code')" name="forget_phone" autofocus="autofocus"
                       autocomplete="off" v-model="getAccount" @blur="searchIos" @keypress="searchAndroid">
            </div>
            <div class="input_verity">
                <div class="input_verity_box verity_box">
                    <input type="text" :placeholder="$t('placeholder_img_verity')" @blur="searchIos" @keypress="searchAndroid"
                           v-model="findVerifyCode" name="verify_code" autofocus="autofocus" autocomplete="off">
                </div>
                <div class="check_code_img" id="forget_verify_code">
                    <img :src="findPsdVerifyImg" alt="" class="verify_code_img" @blur="searchIos"
                         @keypress="searchAndroid" @click="getFindPsdVerifyCodeImg()">
                </div>
            </div>
            <div class="input_verity">
                <div class="input_verity_box mes_verity_box">
                    <input type="text" :placeholder="$t('placeholder_verity')" name="forget_code" v-model="findMsgCheckCode"
                           autofocus="autofocus"
                           autocomplete="off" @blur="searchIos" @keypress="searchAndroid">
                </div>
                <span class="forget_count_down count_down" @click="getMsgCodeFunc()" v-text="$t(forgetPsdMsg)"></span>
            </div>
            <div class="input input2">
                <input type="password" name="forget_password" v-model="forgetPsd1" :placeholder="$t('placeholder_psd')"
                       autofocus="autofocus"
                       autocomplete="off" @blur="searchIos" @keypress="searchAndroid">
            </div>
            <div class="input input3">
                <input type="password" name="forget_password2" v-model="forgetPsd2" :placeholder="$t('placeholder_repeat_psd')"
                       autofocus="autofocus"
                       autocomplete="off" @blur="searchIos" @keypress="searchAndroid">
            </div>
            <button type="button" id="register_login_btn" class="login_btn" @click="submitFunc()">{{$t('submit')}}</button>
        </form>
    </div>
</template>

<script>
    import {Toast} from 'mint-ui';

    export default {
        name: "findPassword",
        data: function () {
            return {
                getAccount: '',
                findPsdVerifyImg: '',
                findVerifyCode: '',
                forgetPsd2: '',
                forgetPsd1: '',
                forgetPsdMsg: 'send_code',
                waitingTime: 120,
                regTel: /^1[345789]\d{9}$/,
                findMsgCheckCode: ''

            }
        },
        directives: {
            focus: {
                inserted(el, {value}) {
                    //页面渲染时，第一个input框聚焦，
                    // console.log(el, {value});
                    if (value) {
                        el.focus();
                    }
                }
            }
        },
        created: function () {
            this.getFindPsdVerifyCodeImg();
            this.$store.commit("set_current", '-1');
            this.$store.commit("set_title", 'personal');
        },
        watch: {
            waitingTime: function (n, o) {
                if (n <= 0) {
                    clearInterval(this.stopWaiting);
                    this.waitingTime = 120;
                    this.forgetPsdMsg = 'send_code';
                    // this.isGetCodeShow = true;
                }
            }
        },
        methods: {
            getFindPsdVerifyCodeImg() {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/User/verify",
                    dataType: "json",
                    data: {}
                })
                    .then(res => {
                        this.findPsdVerifyImg = res.data;
                        console.log(this.findPsdVerifyImg);
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            getMsgCodeFunc() {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/user/checkCode",
                    dataType: "json",
                    data: {
                        verify_code: this.findVerifyCode,
                        username: this.getAccount,
                        act: 6
                    }
                })
                    .then(res => {
                        console.log(res);
                        if (res.data.status == 1) {
                            this.sendMsgToMobile();
                        } else {
                            this.showMsg(res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            sendMsgToMobile() {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/index.php?m=Home&c=Api&a=send_validate_code&scene=6&type=mobile&mobile=" + this.getAccount,
                    dataType: "json",
                    data: {}
                })
                    .then(res => {
                        if (res.data.status == 1) {
                            // this.isGetCodeShow = false;
                            this.countDown();
                            this.showMsg(res.data.msg);
                        } else {
                            this.showMsg(res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            countDown() {
                this.stopWaiting = setInterval(() => {
                    this.waitingTime -= 1;
                    this.forgetPsdMsg = this.waitingTime + "s"
                }, 1000);
            },
            showMsg(msg) {
                Toast({
                    message: msg,
                    duration: 1000
                });
            },
            submitFunc() {
                if (!this.getAccount) {
                    this.showMsg("请输入账号");
                    return false;
                }
                if (!this.regTel.test(this.getAccount)) {
                    this.showMsg("手机号格式不正确");
                    return false;
                }
                if (!this.findVerifyCode) {
                    this.showMsg("图片验证码不能为空");
                    return false;
                }
                if (!this.user_msg_code) {
                    Toast("短信验证码不能为空")
                }
                if (this.forgetPsd1.length < 6 || this.forgetPsd1.length > 20 || this.forgetPsd2.length < 6 || this.forgetPsd2.length > 20) {
                    this.showMsg('请设置6-20位密码');
                    return false;
                }
                if (this.forgetPsd2 != this.forgetPsd1) {
                    this.showMsg("兩次密码不一致");
                    return false;
                }

                // 发送数据
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + '/home/user/rePassword',
                    dataType: "json",
                    data: {
                        forget_phone: this.getAccount,
                        verify_code: this.findVerifyCode,
                        forget_code: this.findMsgCheckCode,
                        forget_password: this.forgetPsd1,
                        forget_password2: this.forgetPsd2,
                    }
                })
                    .then(res => {
                        // console.log(res);
                        if (res.data.status == 1) {
                            this.showMsg(res.data.msg);
                            this.submitSuccess(res.data.result);
                            clearInterval(this.stopWaiting);

                        } else {
                            Toast(res.data.msg);
                        }
                    })
                    .catch(err => {
                        Toast("网络错误，请稍后再试");
                        console.log(err);
                    })

            },
            submitSuccess() {
                // this.$store.commit("set_userInformation", data);
                this.$router.push({path: `/login`});
            },
            searchIos() {
                //ios点击完成失去焦点搜索
                /* this.search();*/
                this.inputBlur();
            },
            searchAndroid(event) {
                //android点击搜索，未能失去焦点，故失去焦点事件无法触发，单可以调用键盘事件处理
                if (event.keyCode == 13) { //如果按的是enter键 13是enter
                    event.preventDefault(); //禁止默认事件（默认是换行）
                    /* this.search();*/
                    this.inputBlur();
                }
            },
            inputBlur() {
                //获取焦点
                const DOM = event.currentTarget.parentElement;// 获取当前节点
                console.log(DOM);
                var nextDOM = DOM.nextElementSibling.firstChild;
                const divDOM = document.querySelector(".input_verity_box");
                if (nextDOM === divDOM) {
                    nextDOM = divDOM.firstChild;
                }

                nextDOM.focus()

            }
        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            },
            userInformation: function () {
                return this.$store.state.personal.userInformation;
            }
        },
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/loginCommon.less';

    .findPassword {
        .media;
    }

    .check_code_img {
        img {
            .img;
        }
    }

    @media (min-width: 768px) and (orientation: portrait) {
        .findPassword {
            width: 375px;
            margin: 47px auto;
            padding: -15px;
            box-shadow: 1px 1px 10px #ccc;
            border-radius: 10px;
        }
    }
</style>
